import ServicePlanTermsTable from 'src/features/servicePlanTerms/components/tables/ServicePlanTermsTable';
import { useServicePlanTabContext } from 'src/features/servicePlans/utils/tabContext';

/** Terms tab of the service plan dashboard; takes the plan's active flag from the outlet context. */
const ServicePlanTermsTab = () => {
    const { isServicePlanActive } = useServicePlanTabContext();

    return <ServicePlanTermsTable isServicePlanActive={isServicePlanActive} />;
};

export default ServicePlanTermsTab;
